<template>
  <v-container fluid>
    <v-row class="mt-10">
      <v-col cols="3">
        <v-btn x-large color="primary" block>Genome</v-btn>
      </v-col>
      <v-col cols="3">
        <v-btn x-large color="primary" block>Exome</v-btn>
      </v-col>
      <v-col cols="3">
        <v-btn x-large color="primary" block>Sanger</v-btn>
      </v-col>
      <v-col cols="3">
        <v-btn x-large color="primary" block>CMA</v-btn>
      </v-col>
    </v-row>
    <v-row class="mt-10">
      <v-col cols="3">
        <v-btn x-large color="primary" block @click="handlePgtClick">PGT</v-btn>
      </v-col>
      <v-col cols="3">
        <v-btn x-large color="primary" block>Paternity test</v-btn>
      </v-col>
      <v-col cols="3">
        <v-btn x-large color="primary" block>Second opinion</v-btn>
      </v-col>
      <v-col cols="3">
        <v-btn x-large color="primary" block>NIPT</v-btn>
      </v-col>
    </v-row>
    <v-row class="mt-10">
      <v-col cols="3">
        <v-btn x-large color="primary" block>Pregnancy preparation</v-btn>
      </v-col>
      <v-col cols="3">
        <v-btn x-large color="primary" block>SMA</v-btn>
      </v-col>
      <v-col cols="3">
        <v-btn x-large color="primary" block>DMD</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'CreateCase',
  methods: {
    handlePgtClick() {
      this.$router.push('/cases/pgt/create')
    }
  }
}
</script>

<style scoped>

</style>